import React from 'react';
import PropTypes from 'prop-types';
import {
  NavLink,
  Route,
} from 'react-router-dom';
import './DataSet.css';
import BarPlot from '../containers/Nuclei/BarPlot';
import BarPlotResults from './Nuclei/BarPlotResults';
import HeatMap from '../containers/Nuclei/HeatMap';
import HeatMapResults from './Nuclei/HeatMapResults';
import VolcanoPlot from './Nuclei/VolcanoPlot';
import VolcanoPlotResults from './Nuclei/VolcanoPlotResults';
import ThalamusAtlas from '../containers/ThalamusAtlas';
import settings from '../settings.json';

import './Nuclei.css';

const thalamusRegions = settings.regionList;


class Nuclei extends React.Component {
  handlePopulationChange = (event) => {
    const { actions } = this.props;
    // grab all the selected options. This is shitty, but I couldn't
    // find a better way on short notice.
    const chosen = [...event.target.options].filter(option => option.selected).map(option => option.value);
    actions.updateCellPopulationChoice(chosen);
  }

  handleOrderChange = (event) => {
    const { actions } = this.props;
    const chosen = [...event.target.options].filter(option => option.selected).map(option => option.value);
    actions.updateCellPopulationOrder(chosen[0]);
  }

  render() {
    const { match, cellPopulation } = this.props;
    return (
      <div className="container nuclei dataset">
        <div className="row">
          <div className="col">
            <h2>Nuclei Data set</h2>
          </div>
        </div>
        <div className="row">
          <div className="col">
            <div className="card">
              <div className="card-header">
                Choose cell population.
              </div>
              <div className="card-body">
                <ThalamusAtlas />
                <div className="form-group">
                  <label htmlFor="cell_population">Cell Population</label>
                  <select multiple="multiple" className="form-control" id="cell_population" name="cell_population" value={cellPopulation.get('chosen').toJS()} onChange={this.handlePopulationChange}>
                    { thalamusRegions.map(region => <option key={region} >{region}</option>)}
                  </select>
                </div>
                <div className="form-group">
                  <label htmlFor="cell_pop_order">Cell Population Ordering</label>
                  <select className="form-control" id="cell_pop_order" name="cell_pop_order" value={cellPopulation.get('order')} onChange={this.handleOrderChange}>
                    <option key="grouped" value="grouped" >Grouped</option>
                    <option key="alpha" value="alpha" >Alphabetical</option>
                    <option key="selected" value="selected" >As Selected</option>
                  </select>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="row">
          <div className="col">
            <div className="card">
              <div className="card-header">
                Run Analysis
              </div>
              <div className="card-body">

                <ul className="nav nav-tabs">
                  <li className="nav-item">
                    <NavLink className="nav-link" to={`${match.url}/barplot`}>Barplot</NavLink>
                  </li>
                  <li className="nav-item">
                    <NavLink className="nav-link" to={`${match.url}/heatmap`}>Heatmap</NavLink>
                  </li>
                  <li className="nav-item">
                    <NavLink className="nav-link" to={`${match.url}/volcano`}>Volcano Plot</NavLink>
                  </li>
                </ul>

                <Route path={`${match.url}/barplot`} component={BarPlot} />
                <Route path={`${match.url}/heatmap`} component={HeatMap} />
                <Route path={`${match.url}/volcano`} component={VolcanoPlot} />
              </div>
            </div>
          </div>
        </div>
        <Route path={`${match.url}/heatmap/:hash`} component={HeatMapResults} />
        <Route path={`${match.url}/barplot/:hash`} component={BarPlotResults} />
        <Route path={`${match.url}/volcano/:hash`} component={VolcanoPlotResults} />

      </div>
    );
  }
}

Nuclei.propTypes = {
  match: PropTypes.object.isRequired,
  cellPopulation: PropTypes.object.isRequired,
  actions: PropTypes.object.isRequired,
};

export default Nuclei;



// WEBPACK FOOTER //
// ./src/components/Nuclei.jsx